import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ActiveCampaign {
  id: string;
  name: string;
  status: string;
  campaign_type: string;
  client_id: string;
  created_at: string;
  updated_at: string;
  version?: string;
}

export const useActiveCampaigns = (clientId: string) => {
  return useQuery({
    queryKey: ['active-campaigns', clientId],
    queryFn: async () => {
      // Always query real Supabase data — campaigns table is populated by edge functions,
      // not dependent on SmartLead API key being present in the browser.
      let query = supabase
        .from('campaigns')
        .select('*')
        .eq('status', 'active');

      // Filter by client_id if not 'all' — no filter means all active campaigns
      if (clientId && clientId !== 'all') {
        query = query.eq('client_id', clientId);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      return data as ActiveCampaign[];
    },
    enabled: !!clientId
  });
};